import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Snel een platte buik, is dat mogelijk?</title>
                <link rel="canonical" href={route("blogs.thirty-one")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE – Personal Training Uden en Schijndel komt met een nieuwe blog. Een van de meeste gehoorde wensen is het hebben van een platte buik. De ronde buik met overtollig vet zijn we allemaal klaar mee en dus is het tijd voor verandering. In deze blog leggen we uit wat de oorzaken zijn van een bolle buik en hoe je een platte buik kan krijgen. Lees je mee?"
                />
                <meta
                    property="og:description"
                    content="WE ARE – Personal Training Uden en Schijndel komt met een nieuwe blog. Een van de meeste gehoorde wensen is het hebben van een platte buik. De ronde buik met overtollig vet zijn we allemaal klaar mee en dus is het tijd voor verandering. In deze blog leggen we uit wat de oorzaken zijn van een bolle buik en hoe je een platte buik kan krijgen. Lees je mee?"
                />
                <meta property="og:url" content={route("blogs.thirty-one")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Snel een platte buik, is dat mogelijk? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/platte-buik.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/platte-buik.webp"
                                    type="image/webp"
                                    alt="Platte buik"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/platte-buik.jpg"
                                    type="image/jpeg"
                                    alt="Platte buik"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/platte-buik.jpg"
                                    alt="Platte buik"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Snel een platte buik, is dat mogelijk?'
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE – Personal Training Uden en Schijndel komt met
                        een nieuwe blog. Een van de meeste gehoorde wensen is
                        het hebben van een platte buik. De ronde buik met
                        overtollig vet zijn we allemaal klaar mee en dus is het
                        tijd voor verandering. In deze blog leggen we uit wat de
                        oorzaken zijn van een bolle buik en hoe je een platte
                        buik kan krijgen. Lees je mee?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom krijgen we sneller buikvet?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer we een ‘vettere’ buik krijgen is zijn er twee
                        oorzaken. De eerste oorzaak is de vetlaag die zich
                        opbouwt onder onze huid. De tweede oorzaak is de
                        vetopslag tussen onze organen en onze buikholte. Deze
                        vorm van vet noemen we visceraal vet. De reden waarom we
                        sneller deze vorm van vet aanmaken heeft te maken met
                        dit soort vet een belangrijk functie heeft, namelijk het
                        beschermen van onze (belangrijke) organen. Het zorgt
                        voor een soort kussen dat onze organen beschermt. Vet
                        speelt, naast deze functie ook een belangrijk rol bij
                        het hormonale proces in ons lichaam. Vetweefsel
                        produceert namelijk leptine. Dit hormoon zorgt ervoor
                        dat we verzadigd raken. Wanneer leptine zijn werkt niet
                        doet blijven we eten omdat we geen gevoel van
                        verzadiging ervaren.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe krijg je al dat buikvet?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer we teveel buikvet ervaren kan dit verschillende
                        redenen hebben. De hoofdreden is een positieve
                        energiebalans waardoor ons lichaamsgewicht toeneemt.
                        Wanneer we meer eten dan we verbranden betekent dit dat
                        ons lichaam de calorieën die hij niet kan gebruiken zal
                        opslaan als vet. Dit doet hij het liefst op de plekken
                        wat de meeste kans van overleven geeft zoals buikvet om
                        onze organen te beschermen. Elk dieet zoals{" "}
                        <a
                            href={route("blogs.second")}
                            className="text-we-are-yellow"
                        >
                            intermittent fasting{" "}
                        </a>
                        werken altijd wanneer je in een calorietekort zit.
                        Redenen zoals{" "}
                        <a
                            href={route("blogs.twenty-eight")}
                            className="text-we-are-yellow"
                        >
                            genetisch aanleg{" "}
                        </a>
                        zijn dus geen excuus!
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Een tweede reden is je hormoonhuishouding. Zoals
                        hierboven te lezen is je energiebalans bepalend of je
                        aankomt of afvalt. Hormonen spelen een rol in waar vet
                        zich zal opslaan wanneer je teveel eet. Om het niet te
                        technische te maken houden we het bij dat hoge insuline
                        en cortisol waardes er voornamelijk voor zorgen dat je
                        meer vet zal opslaan in je buikholte! Cortisol komt vrij
                        wanneer je{" "}
                        <a
                            href={route("blogs.twenty-seven")}
                            className="text-we-are-yellow"
                        >
                            stress{" "}
                        </a>
                        ervaart en insuline bij suikerrijke maaltijden.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Een derde reden is het proces van ouder worden. We
                        worden als mensen allemaal ouder en het gevolg hiervan
                        is dat onze{" "}
                        <a
                            href={route("blogs.twenty-one")}
                            className="text-we-are-yellow"
                        >
                            stofwisseling{" "}
                        </a>{" "}
                        ieder jaar vertraagd. Hierdoor verbranden we minder en
                        komen we sneller in een calorie overschot terecht,
                        gevolg vet! Vrouwen die ouder worden komen vroeg of laat
                        terecht in hun{" "}
                        <a
                            href={route("blogs.eighteenth")}
                            className="text-we-are-yellow"
                        >
                            overgang
                        </a>
                        . Tijdens de overgang maak je lichaam ook een hormonale
                        overgang waardoor er meer vetopslag rondom de heupen en
                        buik ontstaat.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom moeten we van buikvet af?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Hogere vetwaardes op onze buik zijn slecht voor onze
                        gezondheid. Het verstoort de werking van onze organen en
                        stofwisseling. Onderzoeken tonen al jaren aan dat een
                        teveel aan buikvet een hogere kans veroorzaakt op hart,
                        - en vaatziekten, diabetes en insuline ongevoeligheid!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe komen we snel van buikvet af?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het antwoord op deze vraag is weer simpel: wat
                        verbranden vet wanneer we in een calorietekort zitten.
                        Andere manieren zijn niet mogelijk. Fabeltjes zoals het
                        drinken van citroenwater of het trainen met zweetbanden
                        rondom je buik dragen niet bij een aan platte buik. Om
                        je nogmaals wakker te schudden melden we opnieuw dat
                        ervoor moet zorgen dat je calorie inname verlaagt door
                        je voeding aan te passen en je calorie uitgave verhoogt
                        door meer te gaan bewegen en sporten. Daarnaast is het
                        laag houden van je cortisol niveaus een aanrader. Zorg
                        er dus voor dat je minder stress ervaart door te oefenen
                        met ademhalingstechnieken en positieve psychologie toe
                        te passen in je leven.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
